<template>
<div>
  <div v-if="error"><h2 class="text-center">{{error}}</h2></div>
  
  <div v-if="loading==true" class="container">
    <div class="text-center">
      <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
    </div>
  </div>  <!-- closing the loading container-->
  <div v-if="reservationReadyComp && isActiveComp==true  && !loading" class="container">
    <h2 style="margin-bottom:0px;" class="small-h2 text-center"><i class="fa fa-list-alt"></i> Booking ID: <strong>{{existingReservationComp.BookingNumber}} </strong></h2>
  
      <hr style="margin-top:5px;">

    <div class="modal fade" id="ratingRequest" role="dialog" aria-labelledby="modalLabel" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h4><i class="fa fa-thumbs-o-up" aria-hidden="true"></i> How would you rate {{existingReservationComp.SitterName}}?</h4>
            </div>

                <div class="modal-body " style="overflow:hidden;">
                        <div class="well">
                            <div >
                                 <star-rating :show-rating="false" :border-width="3" @rating-selected="setRating"></star-rating>
                                 <hr>
                                <textarea class="form-control" rows="3" v-model="reviewDesc" placeholder="We would love to hear your feedback on this stay" id="comment"></textarea>
                            </div>
                        </div>
        

                <div class="pull-right">
                    <button type="button" class="btn btn-success" :disabled="!customerRating"  @click="submitRating()" >Send Rating</button>     
                </div>
            </div>
          </div>
        </div>
    </div>
    <!-- end of modal-->
   
      <div>
        <div class="hidden-lg hidden-md">
            <button @click="switchCollapse()" class="hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title" data-toggle="collapse" data-target="#summary"> <i class="fa fa fa-navicon" /> &nbsp {{summaryComp}}</button>
            
            <div class=" hidden-md hidden-lg collapse" id="summary" style="margin-left:0px;padding-left:0px; margin-right:0px; padding-right:0px">
                
                <div class="reservationSummary">
                   <div v-for="petCard in existingReservationComp.AvailablePetDtos">
                    <div>
                        <PetSelectCard :showDetails='true' v-bind:petId="petCard.PetId" :key="petCard.PetId"></PetSelectCard>
                    </div>
                    </div>
            
                    <div class="summary-desc">
                    <h5  v-if="!isDogWalking">Total Days: {{existingReservationComp.TotalDays}}</h5>
                    <h5  v-if="!isDogWalking">Dates: {{startDateComp}} - {{endDateComp}}</h5>

                    <h5 v-if="isDogWalking">Starting {{startDateComp}}</h5>

                    <h5 v-for="service in existingReservationComp.ServicePriceSummaryDtos">{{service.Description}}</h5>
                    <h4 class="text-success">Total Price: {{totalPriceComputed}} {{currencyComp}} <span v-if="isDogWalking"> per week</span></h4>
                  
                     
                    </div>

                </div>
                
            </div>
            
            <br>
            
        </div>

        <div class="col-xs-12 col-sm-12 col-md-7 remove-margins">
        <div v-if="existingReservationComp.CustomerStatus" class="alert alert-dismissible" :class="existingReservationComp.StatusClass" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h5 ><strong>Status: </strong>{{existingReservationComp.CustomerStatus}}</h5>
          </div>
           <div class="media-left">
                <img :src="existingReservationComp.SitterProfilePic" alt="" class="media-object img-responsive img-circle" height="25" width="25"></img>
           </div>
            
           <div class="media-left head-title">
                <h4 class="media-heading " style="padding-bottom:0px;margin-bottom:0px;"> {{existingReservationComp.SitterName}}</h4>
                
          </div>
          <Chat v-if="signalReadyComp" :isSitterAccepted="existingReservationComp.IsSitterAccepted"  :transactionId="reservationIdComp"></Chat>
          <br>
                     
         <div class="buttons" v-if="!rejectedComp">
    
            <button style="margin-bottom:5px;" data-toggle="popover" v-show="!existingReservation.IsConfirmedBooking"  @click="confirmBooking()" v-if="existingReservation.IsSitterAccepted==true" class="btn btn-title btn-block btn-success">
            <i class="fa fa-check-o"></i>
            Confirm Booking</button>
            <div >
            <div v-if="existingReservationComp.StatusCode==0" style="margin-bottom:10px;" class="text-center">
            <a href="javascript:;" @click="whatToDoNext()">What should I do now?</a>
            </div>
                <button class="btn btn-block  btn-warning" data-toggle="popover"  v-if="existingReservationComp.IsCustomerCancelled==false" @click="cancelRequest()"><i class="fa fa-trash-o"></i> Cancel Request</button>
                <br>
            </div>
        
        </div>
         
        <button class="btn btn-block btn-info btn-lg" @click="goMyReservations()">View all Bookings</button>
        <button class="btn btn-block btn-success btn-lg" @click="findSitters()">Find More Sitters <i class="fa fa-paw"></i></button>
           
        </div>
         
        <div class="hidden-xs hidden-sm col-md-4 pull-right reservationSummary">
           <h4 class="text-center"> Summary </h4>
            
            <div v-for="petCard in existingReservationComp.AvailablePetDtos">
              <div>
                <PetSelectCard :showDetails='true' v-bind:petId="petCard.PetId" :key="petCard.PetId"></PetSelectCard>
              </div>
            </div>
            
            <h5 v-if="!isDogWalking" class="small">Total Days: {{existingReservationComp.TotalDays}}</h5>
            <h5 v-if="!isDogWalking" class="small">Dates: {{startDateComp}} - {{endDateComp}}</h5>
            <h5 v-if="isDogWalking">Starting {{startDateComp}}</h5>
            <h5 class="small" v-for="service in existingReservationComp.ServicePriceSummaryDtos">{{service.Description}}</h5>
            <h4 class="text-success">Total Price: {{totalPriceComputed}} {{currencyComp}} <span v-if="isDogWalking"> per week</span></h4>
            
        </div>
     </div>
     
      
        
        

      


    
        
        
    

    
  </div>  <!-- closing the main container-->


  <div v-if="isActiveComp==false">
        <br>
        <h1 class="text-center">You need to have an active membership to view this reservation</h1>
        <p class="text-center">Note: Only pet sitters who are Premium can respond to you without an active membership</p>
        <div class="col-md-4 col-md-offset-4">
        <br>
        <button class="btn btn-block btn-success" @click="goSubscribe()">Subscribe Now</button>
        </div>
  </div>
</div>
</template>
<script>

import StarRating from 'vue-star-rating'
import Chat from '../../SharedComponents/Chat'
import auth from '../../../auth'
import store from '../../../data/store'
import PetSelectCard from '../../SharedComponents/PetSelectCard'
import router from '../../../router'

export default {
    data () {
        return {
            existingReservation: null,
            notification:'',
            reviewDesc: '',
            error: '',
            isDogWalking: false,
            summaryCollapse: true,
            sending: false,
            ready: true,
            customerRating: '',
            rated: false,
            sent: false,
            loading: true,
            reviewDto: {
                Description: '',
                Rating: ''
            },

        }
    },
    components: {
        PetSelectCard,
        Chat,
        StarRating
    },
    updated: function() {
        var self = this

      $('[data-toggle="popover"]').popover();
      if (this.existingReservationComp!=null)
        if (this.existingReservationComp.IsCompleted == true && this.existingReservationComp.RatingRequired == true)
            $('#ratingRequest').modal('show')

       
   
    

    // $zopim(function (){
    //     $zopim.livechat.sendVisitorPath();
    // });
    $('#summary').collapse('show');
     
    },
    computed: {
        isActiveComp: function(){
            if (this.existingReservationComp!=null)
                return this.existingReservationComp.IsSitterCustomerActive
        },
        currencyComp: function(){
            return store.getters.CountryData.Currency
        },
        rejectedComp: function(){
            var self = this
            if (self.existingReservationComp.IsSitterRejected == true || self.existingReservationComp.IsCustomerCancelled == true)
                return true
            else    
                return false
        },
        summaryComp: function(){
            if (this.summaryCollapse==true)
                return 'Hide Summary'
            else 
                return 'Show Summary'
        },
        totalPriceComputed: function(){
            var totalPrice = this.existingReservation.TotalPrice
            return  totalPrice
        },
        startDateComp: function(){
            var self = this
            return moment(self.existingReservation.StartDate).format('DD MMM YYYY')
        },
        endDateComp: function(){
            var self = this
            return moment(self.existingReservation.OriginalEndDate).format('DD MMM YYYY')
        },
        signalReadyComp: function(){
        if (store.getters.SignalRHub!=null && this.ready==true)
            if (store.getters.SignalRHub.connection!=null)
                return true
            return false
        },
        signalRHubComp: function(){
            if (store.getters.SignalRHub!=null)
                return store.getters.SignalRHub
        },
        existingReservationComp: function(){
            return this.existingReservation
        },
        reservationIdComp: function(){
            var self=this;
            if (self.$route.params!=null)
            return self.$route.params.reservationId
        },
        reservationReadyComp: function(){
            if (this.existingReservation!=null && this.signalReadyComp==true)
                return true
            return false
        },
   
    },
    watch: {
        '$route.params.reservationId': function(){
            this.ready=false
            this.initReservation()
            this.$forceUpdate()
        }
    },
    methods: {
        confirmBooking: function(){
            var self = this
            self.existingReservation.IsConfirmedBooking = true
            self.signalRHubComp.invoke('UpdateReservation',self.existingReservation,store.getters.userRole)
            $.ajax("https://www.dupaws.com/services/api/customer/confirmBooking/" + self.$route.params.reservationId, {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        
                    },
                    error: function(data, status, error) {
                        swal("Oops","failure happened when you tried to confirm booking, contact support","info")
                  }
                    
            }); 
        },
        dateFormatter: function(date){
            return moment(date).format('DD MMM YYYY')
        },
        setRating: function (rating){
            this.customerRating = rating
            this.reviewDto.Rating = rating
            this.reviewDto.Description = this.reviewDesc
            
        },
        submitRating(){
            var self = this
            self.reviewDto.Description = self.reviewDesc
            self.reviewDto.Rating = self.customerRating
            self.customerRating = ''
            $.ajax("https://www.dupaws.com/services/api/customer/submitReview/" + self.$route.params.reservationId, {
                    type: 'POST',
                    data: JSON.stringify(self.reviewDto),
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        self.alert=data
                        $('#ratingRequest').modal('hide')
                             swal({
                        title: "Thank you for your feedback!",
                        type: "success",
                        confirmButtonClass: 'btn-info',
                        confirmButtonText: "OK",
                        closeOnConfirm: true,
                        html: true
                        }, function(){
                            router.push({path: '/'})
                        });
                    },
                    error: function(data, status, error) {
                        
                    
                  }
                    
            }); 
        },
        whatToDoNext: function(){
            var self = this
               swal({
                            title: 'Request has been sent',
                            text: self.existingReservationComp.SitterName + " will be notified of your request, you can use chat to send a message. also we suggest that you request at least another sitter in case " + self.existingReservationComp.SitterName + " is busy or not available.",
                            type: "success",
                            confirmButtonClass: "btn-success",
                            confirmButtonText: 'Woof!',
                            allowOutsideClick: false,
                            closeOnConfirm: true,
                            },
                            function(isConfirm) {
                                return;
                            
                            });
        },
        goSubscribe: function(){
            var self = this
            self.$router.push({path: '/subscribe'})
            self.$router.go({path: '/subscribe'})
        },  
        goSupport(){
             router.push({
                path: '/contact-support/' + '?bookingId=' + this.existingReservationComp.BookingNumber,
                force: true
                })
        },
        cancelRequest(){
            var self = this
            self.existingReservation.IsCustomerRemoved = true
            self.existingReservation.IsCustomerCancelled = true
            self.existingReservation.CustomerCancelledDate = new Date()
            self.signalRHubComp.invoke('UpdateReservation',self.existingReservation,store.getters.userRole)
        },
        switchCollapse(){
            if (this.summaryCollapse==true)
                this.summaryCollapse=false
            else
                this.summaryCollapse=true
        },
        initReservation(){
            var self = this
            self.loading = true
            $.ajax("https://www.dupaws.com/services/api/customer/getReservation/" + self.$route.params.reservationId, {
                    type: 'GET',
                    beforeSend: function(xhr){
                        xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                    },
                    dataType:"json",
                    contentType: "application/json; charset=utf-8",
                    crossDomain: true,
                    success: function (data) {
                        self.existingReservation = data
                         $.each(data.AvailableSitterServiceDtos, function(index, item){
                                if (item.ServiceType==6 && item.IsSelected==true)
                                    self.isDogWalking = true
                        })
                        
                        self.ready = true
                        self.loading = false
                    },
                    error: function(data, status, error) {
                        self.loading = false
                        self.error = data.responseJSON.Message
                    
                  }
                    
            }); 

        },
        findSitters: function(){
            this.$router.push({path: '/findsitters'})
        },
        goMyReservations: function(){
            this.$router.push({path: '/my-reservations'})
        },
        updateReservation: function(){
            var self = this
            this.signalRHubComp.invoke('UpdateReservation',self.existingReservation ,store.getters.userRole)
        },
    },
    mounted: function () {
       var self = this;
       this.$ga.page(this.$router)
       self.$forceUpdate();
       self.initReservation()
       store.commit('readNotificationTrans',self.reservationIdComp)

       
       self.signalRHubComp.on('UpdateReservation', function(reservationDto){
            if (reservationDto.ServiceTransactionId==self.existingReservation.ServiceTransactionId)
                self.existingReservation = reservationDto
       }) 



    }
  

}
 
</script>
<style scoped>
.modal {
  text-align: center;
}

 .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.reservationSummary{
    border: 1px;
    
    border-style: solid;
    border-color:#c3c3c3;
    border-radius: 5px;
    background: whitesmoke;
}

.border-style{
    border: 1px #a6adad;
    border-style: solid;
    border-radius: 5px;
    margin:5px;
    padding:5px;
}

.summary-desc{
    margin:10px;
}

.some-style{
    background-color: white;
    padding: 1px;
    border-radius: 2px;
    border: 5px #09589e;
    box-shadow: 0 0 0 2px #e0e0e0;
    
    margin-bottom:3%;
}

.text-success {
    color: #62c364;
}

.flex-item{
    margin:3px;
}

.btn-default:hover {
    color: #333;
    background-color: #ffffff;
    border-color: #a7a7a7;
}

.btn-default:focus, .btn-default.focus {
    color: #333;
    background-color: white;
    border-color: #8c8c8c;
}


.text-price{
   font-family: 'Yanone Kaffeesatz', sans-serif;
  font-weight: 600;
  font-size: 1.95em;
  color: #737574;
  padding-bottom: 0;
}

.list-flex{
    max-width:500px;
    display:flex;
    
    
}


.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}


</style>


// WEBPACK FOOTER //
// ViewReservationComponent.vue?e226cce6